import { Component } from '@angular/core';
import { routerTransition } from './router.animations';
import { ContentfulService } from './contentful.service';
import { Entry } from 'contentful';

@Component({
  selector: 'app-root',
  animations: [ routerTransition ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  mobHeight: any;
  mobWidth: any;
  constructor(public contentfulService: ContentfulService) { 
      this.mobHeight = (window.innerWidth) + "px";
      this.mobWidth = (window.innerWidth) + "px";
      console.log(this.mobHeight);
      console.log(this.mobWidth);
  }
  
  title = 'Tim van Wankum';
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }

  ngOnInit() {
    this.contentfulService.getItems()
    .then(items => this.contentfulService.items = items);
  
    this.contentfulService.getAbout()
    .then(items => this.contentfulService.about = items);
  }
}



// WEBPACK FOOTER //
// C:/Users/timva/Documents/Work/LatestDownload/src/app/app.component.ts